module.exports = __webpack_public_path__ + "static/media/help.b256199b.svg";


//////////////////
// WEBPACK FOOTER
// ./src/routes/Shop/assets/help.svg
// module id = 792
// module chunks = 20